import "./App.css";
import "./responsive.css";
import "react-toastify/dist/ReactToastify.css";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import HomeScreen from "./screens/HomeScreen";
import Login from "./screens/Login";
import Register from "./screens/Register";
import CartScreen from "./screens/CartScreen";
import ShippingScreen from "./screens/ShippingScreen";
import ProfileScreen from "./screens/ProfileScreen";
import PaymentScreen from "./screens/PaymentScreen";
import PlaceOrderScreen from "./screens/PlaceOrderScreen";
import OrderScreen from "./screens/OrderScreen";

import PrivateRouter from "./PrivateRouter";

import SingleGroup from "./screens/SingleGroup";
import LoginOtp from "./screens/LoginOtp";
import PolicyScreen from "./screens/PolicyScreen";
import TermConditionScreen from "./screens/TermConditionScreen";
import DisclaimerScreen from "./screens/DisclaimerScreen";
import SingleProduct from "./screens/SingleProduct.js";
import ClothingProductScreen from "./screens/ClothingProductScreen.js";

import NotFound from "./screens/NotFound"; // NEW 404 PAGE

const App = () => {
  return (
    <Router>
      <Switch>
      
        {/* Group Page */}
        <Route exact path="/group/:id" component={SingleGroup} />

        {/* Product Page */}
        <Route exact path="/products/:id" component={SingleProduct} />

        {/* Clothing Individual Product */}
        <Route
          exact
          path="/clothing/product/:id"
          component={ClothingProductScreen}
        />

        {/* Search */}
        <Route exact path="/search/:keyword" component={HomeScreen} />

        {/* Auth + Static */}
        <Route exact path="/login-strict" component={Login} />
        <Route exact path="/login" component={LoginOtp} />
        <Route exact path="/login-otp" component={LoginOtp} />
        <Route exact path="/register/:refId" component={Register} />
        <Route exact path="/register" component={Register} />

        <PrivateRouter exact path="/profile" component={ProfileScreen} />
        <Route exact path="/cart/:id?" component={CartScreen} />
        <PrivateRouter exact path="/shipping" component={ShippingScreen} />
        <PrivateRouter exact path="/payment" component={PaymentScreen} />
        <PrivateRouter exact path="/placeorder" component={PlaceOrderScreen} />
        <PrivateRouter exact path="/order/:id" component={OrderScreen} />

        <Route exact path="/policy" component={PolicyScreen} />
        <Route exact path="/disclaimer" component={DisclaimerScreen} />
        <Route exact path="/term-condition" component={TermConditionScreen} />

        {/* <Route
          exact
          path="/category/:pageCategory/:id"
          component={HomeScreen}
        /> */}
        {/* <Route exact path="/category/:pageCategory" component={HomeScreen} /> */}
        <Route exact path="/:pageCategory/:id" component={HomeScreen} />
        <Route exact path="/:pageCategory" component={HomeScreen} />

        {/* Home */}
        <Route exact path="/" component={HomeScreen} />

        {/* 404 (should always be LAST) */}
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};

export default App;

//Temp Backup (Will be Removed soon)

// import "./App.css";
// import "./responsive.css";
// import "react-toastify/dist/ReactToastify.css";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import HomeScreen from "./screens/HomeScreen";
// import Login from "./screens/Login";
// import Register from "./screens/Register";
// import CartScreen from "./screens/CartScreen";
// import ShippingScreen from "./screens/ShippingScreen";
// import ProfileScreen from "./screens/ProfileScreen";
// import PaymentScreen from "./screens/PaymentScreen";
// import PlaceOrderScreen from "./screens/PlaceOrderScreen";
// import OrderScreen from "./screens/OrderScreen";
// import PrivateRouter from "./PrivateRouter";
// import SingleGroup from "./screens/SingleGroup";
// import LoginOtp from "./screens/LoginOtp";
// import PolicyScreen from "./screens/PolicyScreen";
// import TermConditionScreen from "./screens/TermConditionScreen";
// import DisclaimerScreen from "./screens/DisclaimerScreen";
// import SingleProduct from "./screens/SingleProduct.js";
// import ClothingProductScreen from "./screens/ClothingProductScreen.js";

// const App = () => {
//   return (
//     <Router>
//       <Switch>
//         <Route path="/category/:pageCategory/:id" element={HomeScreen} />
//         <Route path="/category/:pageCategory" element={HomeScreen} />
//         <Route path="/:pageCategory/:id" element={HomeScreen} />
//         <Route path="/:pageCategory" element={HomeScreen} />
//         <Route path="/" exact component={HomeScreen} />
//         <Route path="/search/:keyword" component={HomeScreen} exact />

//         <Route path="/group/:id" component={SingleGroup} />
//         <Route path="/products/:id" component={SingleProduct} />
//         <Route path="/login-strict" component={Login} />
//         <Route path="/login" component={LoginOtp} />
//         <Route path="/login-otp" component={LoginOtp} />
//         <Route path="/register/:refId" component={Register} />
//         <Route path="/register" component={Register} />
//         <PrivateRouter path="/profile" component={ProfileScreen} />
//         <Route path="/cart/:id?" component={CartScreen} />
//         <PrivateRouter path="/shipping" component={ShippingScreen} />
//         <PrivateRouter path="/payment" component={PaymentScreen} />
//         <PrivateRouter path="/placeorder" component={PlaceOrderScreen} />
//         <PrivateRouter path="/order/:id" component={OrderScreen} />
//         <Route path="/policy" component={PolicyScreen} />
//         <Route path="/disclaimer" component={DisclaimerScreen} />
//         <Route path="/term-condition" component={TermConditionScreen} />

//         {/* Temp route for clothing */}
//         <Route
//           path="/clothing/product/:id"
//           component={ClothingProductScreen}
//           exact
//         />

//         <Route path="*" component={HomeScreen} />
//       </Switch>
//     </Router>
//   );
// };

// export default App;